export default __webpack_public_path__ + "static/media/hht2_storybook_06.908441fb.png";